// import BusinessIcon from "@mui/icons-material/Business";
// import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
// import ClearIcon from "@mui/icons-material/Clear";
// import CloseIcon from "@mui/icons-material/Close";
// import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
// import FilterListIcon from "@mui/icons-material/FilterList";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import SearchIcon from "@mui/icons-material/Search";
// import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
// import { Autocomplete } from "@mui/material";
// import {
//   Box,
//   Button,
//   Chip,
//   CircularProgress,
//   FormControl,
//   IconButton,
//   InputAdornment,
//   InputLabel,
//   MenuItem,
//   Modal,
//   Select,
//   SelectChangeEvent,
//   TextField,
//   Tooltip,
//   Typography,
// } from "@mui/material";
// import Grid from "@mui/material/Grid2";
// import Paper from "@mui/material/Paper";
// import { styled } from "@mui/material/styles";
// import { useEffect, useMemo, useState } from "react";
// import { AppliedJobsTable } from "./applied-jobs-table";
// import CardScrolingTem from "../dashboard/card-scroling-tem";
// import { useUser } from "@/client/services/user";
// import {
//   JobFeedback,
//   InternshipJobApplicationRecord,
//   fetchStudentInternshipJobs,
//   openInternshipJobLink,
//   saveInternshipJobFeedback,
// } from "@/client/services/internship-jobs";
// import { CustomDatePicker } from "./Customdatepicker";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import axios from "axios";

// interface Job {
//   unique_id: string;
//   company: string;
//   job_title: string;
//   location: string;
//   emp_type: string[];
//   job_type: string[];
//   tag: string;
//   source: string;
//   date_posted?: string;
//   linked_date_posted?: string;
//   job_post_link: string;
//   job_details: {
//     experience_required: string;
//     degree_required: string;
//     employment_type: string[];
//   };
//   jd: string;
// }

// function dedupeJobs(jobs: Job[]) {
//   const seen = new Set<string>();
//   return jobs.filter((job) => {
//     const key =
//       job.unique_id?.trim() ||
//       [
//         job.job_title?.trim().toLowerCase(),
//         job.company?.trim().toLowerCase(),
//         job.location?.trim().toLowerCase(),
//         job.job_post_link?.trim(),
//       ].join("::");
//     if (!key || seen.has(key)) {
//       return false;
//     }
//     seen.add(key);
//     return true;
//   });
// }

// const JobCard = styled(Paper)(({ theme }) => ({
//   backgroundColor: "#fff",
//   borderRadius: "12px",
//   padding: theme.spacing(2.5),
//   marginBottom: "14px",
//   boxShadow: "0px 1px 4px rgba(0,0,0,0.08)",
//   border: "1px solid #eaf0fb",
//   transition: "box-shadow 0.2s, border-color 0.2s",
//   "&:hover": {
//     boxShadow: "0px 4px 16px rgba(25, 118, 210, 0.12)",
//     borderColor: "#90caf9",
//   },
// }));

// const FilterBar = styled(Box)(({ theme }) => ({
//   display: "flex",
//   flexWrap: "wrap",
//   alignItems: "center",
//   gap: theme.spacing(1.5),
//   padding: theme.spacing(1.75, 2),
//   backgroundColor: "#f7faff",
//   borderRadius: "12px",
//   border: "1px solid #dde8fb",
//   marginBottom: theme.spacing(1.5),
// }));

// function formatDate(dateStr?: string) {
//   if (!dateStr) return "-";
//   const date = new Date(dateStr);
//   return Number.isNaN(date.getTime())
//     ? dateStr
//     : date.toLocaleDateString(undefined, {
//         year: "numeric",
//         month: "short",
//         day: "numeric",
//       });
// }

// const filterSelectSx = {
//   fontSize: "13px",
//   bgcolor: "#fff",
//   borderRadius: "8px",
//   width: 140,
//   minWidth: 140,
//   maxWidth: 140,
//   "& .MuiSelect-select": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
//   "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
//   "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
//   "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" },
// };

// const getFeedbackLabel = (feedback?: JobFeedback) => {
//   if (feedback === "applied") return "Applied";
//   if (feedback === "not_applied") return "Not Applied";
//   return "Pending Feedback";
// };

// const getCardActionLabel = (record?: InternshipJobApplicationRecord) => {
//   if (!record) return "Apply";
//   if (record.feedback === "applied") return "Applied";
//   if (record.feedback === "not_applied") return "Not Applied";
//   if (record.applicationOpenedAt) return "Pending Feedback";
//   return "Apply";
// };

// function JobsReportPagePreview() {
//   const [jobs, setJobs] = useState<Job[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);
//   const [jdModal, setJdModal] = useState<Job | null>(null);
//   const [applyModal, setApplyModal] = useState<Job | null>(null);
//   const [applyLoading, setApplyLoading] = useState(false);
//   const [feedbackLoading, setFeedbackLoading] = useState<JobFeedback | null>(null);
//   const [applicationsLoading, setApplicationsLoading] = useState(true);
//   const [applicationMap, setApplicationMap] = useState<
//     Record<string, InternshipJobApplicationRecord>
//   >({});
//   const { user } = useUser();
//   const [search, setSearch] = useState("");
//   const [filterLocation, setFilterLocation] = useState("All");
//   const [filterEmpType, setFilterEmpType] = useState("All");
//   const [filterJobType, setFilterJobType] = useState("All");
//   const [filterSource, setFilterSource] = useState("All");
//   const [filterStartDate, setFilterStartDate] = useState("");
//   const [filterEndDate, setFilterEndDate] = useState("");
//   const [showAppliedJobs, setShowAppliedJobs] = useState(false);

//   useEffect(() => {
//     const fetchJobs = async () => {
//       try {
//         setLoading(true);
//         setError(null);
//         const res = await axios.get(`/api/internship-jobs`);
//         const nextJobs = Array.isArray(res.data) ? res.data : (res.data.jobs ?? []);
//         setJobs(dedupeJobs(nextJobs));
//       } catch (fetchError: unknown) {
//         const errorMessage =
//           fetchError instanceof Error ? fetchError.message : "An unexpected error occurred.";
//         setError(errorMessage);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchJobs();
//   }, []);

//   useEffect(() => {
//     const loadStudentApplications = async () => {
//       if (!user?.studentId) {
//         setApplicationMap({});
//         setApplicationsLoading(false);
//         return;
//       }
//       try {
//         setApplicationsLoading(true);
//         const records = await fetchStudentInternshipJobs(user.studentId);
//         const nextMap = records.reduce<Record<string, InternshipJobApplicationRecord>>(
//           (accumulator, current) => {
//             accumulator[current.jobUniqueId] = current;
//             return accumulator;
//           },
//           {},
//         );
//         setApplicationMap(nextMap);
//       } catch {
//         setApplicationMap({});
//       } finally {
//         setApplicationsLoading(false);
//       }
//     };
//     loadStudentApplications();
//   }, [user?.studentId]);

//   const locationOptions = useMemo(
//     () => ["All", ...Array.from(new Set(jobs.map((job) => job.location).filter(Boolean))).sort()],
//     [jobs],
//   );

//   const empTypeOptions = useMemo(
//     () => ["All", ...Array.from(new Set(jobs.flatMap((job) => job.emp_type ?? []))).sort()],
//     [jobs],
//   );

//   const jobTypeOptions = useMemo(
//     () => ["All", ...Array.from(new Set(jobs.flatMap((job) => job.job_type ?? []))).sort()],
//     [jobs],
//   );

//   const sourceOptions = useMemo(
//     () => ["All", ...Array.from(new Set(jobs.map((job) => job.source).filter(Boolean))).sort()],
//     [jobs],
//   );

//   const filteredJobs = useMemo(() => {
//     const query = search.toLowerCase().trim();
//     const normalize = (value: string) => value.toLowerCase().trim();
//     const startDate = filterStartDate ? new Date(`${filterStartDate}T00:00:00`) : null;
//     const endDate = filterEndDate ? new Date(`${filterEndDate}T23:59:59.999`) : null;

//     return jobs.filter((job) => {
//       const jobDateValue = job.date_posted ?? job.linked_date_posted;
//       const jobDate = jobDateValue ? new Date(jobDateValue) : null;

//       if (
//         query &&
//         !normalize(job.job_title ?? "").includes(query) &&
//         !normalize(job.company ?? "").includes(query) &&
//         !normalize(job.jd ?? "").includes(query)
//       ) {
//         return false;
//       }
//       if (filterLocation !== "All" && normalize(job.location ?? "") !== normalize(filterLocation)) {
//         return false;
//       }
//       if (
//         filterEmpType !== "All" &&
//         !(job.emp_type ?? []).some((value) => normalize(value) === normalize(filterEmpType))
//       ) {
//         return false;
//       }
//       if (
//         filterJobType !== "All" &&
//         !(job.job_type ?? []).some((value) => normalize(value) === normalize(filterJobType))
//       ) {
//         return false;
//       }
//       if (filterSource !== "All" && normalize(job.source ?? "") !== normalize(filterSource)) {
//         return false;
//       }
//       if (startDate && (!jobDate || Number.isNaN(jobDate.getTime()) || jobDate < startDate)) {
//         return false;
//       }
//       if (endDate && (!jobDate || Number.isNaN(jobDate.getTime()) || jobDate > endDate)) {
//         return false;
//       }
//       return true;
//     }).sort((a, b) => {
//       const dateA = a.date_posted ?? a.linked_date_posted;
//       const dateB = b.date_posted ?? b.linked_date_posted;
//       if (!dateA && !dateB) return 0;
//       if (!dateA) return 1;
//       if (!dateB) return -1;
//       return new Date(dateB).getTime() - new Date(dateA).getTime();
//     });
//   }, [jobs, search, filterLocation, filterEmpType, filterJobType, filterSource, filterStartDate, filterEndDate]);

//   const hasActiveFilters =
//     search !== "" ||
//     filterLocation !== "All" ||
//     filterEmpType !== "All" ||
//     filterJobType !== "All" ||
//     filterSource !== "All" ||
//     filterStartDate !== "" ||
//     filterEndDate !== "";

//   const clearFilters = () => {
//     setSearch("");
//     setFilterLocation("All");
//     setFilterEmpType("All");
//     setFilterJobType("All");
//     setFilterSource("All");
//     setFilterStartDate("");
//     setFilterEndDate("");
//   };

//   const updateApplicationMap = (record: InternshipJobApplicationRecord) => {
//     setApplicationMap((previous) => ({ ...previous, [record.jobUniqueId]: record }));
//   };

//   const handleOpenPosting = async (job: Job) => {
//     if (!user?.studentId) return;
//     try {
//       setApplyLoading(true);
//       const record = await openInternshipJobLink({
//         studentId: user.studentId,
//         studentName: user.name,
//         studentEmail: user.email,
//         studentRollNo: user.rollNo,
//         jobUniqueId: job.unique_id,
//         jobTitle: job.job_title,
//         company: job.company,
//         location: job.location,
//         source: job.source,
//         jobPostLink: job.job_post_link,
//       });
//       updateApplicationMap(record);
//       window.open(job.job_post_link, "_blank", "noopener,noreferrer");
//     } finally {
//       setApplyLoading(false);
//     }
//   };

//   const handleSaveFeedback = async (job: Job, feedback: JobFeedback) => {
//     if (!user?.studentId) return;
//     try {
//       setFeedbackLoading(feedback);
//       const record = await saveInternshipJobFeedback({
//         studentId: user.studentId,
//         jobUniqueId: job.unique_id,
//         feedback,
//       });
//       updateApplicationMap(record);
//       setApplyModal(null);
//     } finally {
//       setFeedbackLoading(null);
//     }
//   };

//   const selectedJobRecord = applyModal ? applicationMap[applyModal.unique_id] : undefined;
//   const hasOpenedSelectedJob = Boolean(selectedJobRecord?.applicationOpenedAt);

//   const appliedJobRecords = useMemo(
//     () =>
//       Object.values(applicationMap).sort(
//         (left, right) =>
//           new Date(right.updatedAt ?? right.createdAt).getTime() -
//           new Date(left.updatedAt ?? left.createdAt).getTime(),
//       ),
//     [applicationMap],
//   );

//   return (
//     <Box sx={{ flexGrow: 1, px: 1 }}>
//       <Grid size={8}>
//         {/* Tab Navigation */}
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "flex-end",
//             mb: 1.5,
//             borderBottom: "2px solid #e0e7f3",
//             position: "sticky",
//             top: 0,
//             zIndex: 10,
//             bgcolor: "background.default",
//           }}
//         >
//           <Box
//             onClick={() => setShowAppliedJobs(false)}
//             sx={{
//               px: 2,
//               py: 1,
//               cursor: "pointer",
//               fontSize: "15px",
//               fontWeight: showAppliedJobs ? 500 : 700,
//               color: showAppliedJobs ? "text.secondary" : "primary.main",
//               borderBottom: showAppliedJobs ? "2px solid transparent" : "2px solid #1976d2",
//               mb: "-2px",
//               transition: "color 0.15s",
//               userSelect: "none",
//               "&:hover": { color: "primary.main" },
//             }}
//           >
//             Jobs
//           </Box>
//           <Box
//             onClick={() => setShowAppliedJobs(true)}
//             sx={{
//               px: 2,
//               py: 1,
//               cursor: "pointer",
//               fontSize: "15px",
//               fontWeight: showAppliedJobs ? 700 : 500,
//               color: showAppliedJobs ? "primary.main" : "text.secondary",
//               borderBottom: showAppliedJobs ? "2px solid #1976d2" : "2px solid transparent",
//               mb: "-2px",
//               transition: "color 0.15s",
//               userSelect: "none",
//               "&:hover": { color: "primary.main" },
//             }}
//           >
//             Job Status
//           </Box>
//         </Box>
//       </Grid>

//       {!showAppliedJobs && (
//         <FilterBar sx={{ flexWrap: "nowrap", alignItems: "center", gap: 1, py: 1.25 }}>
//           <FilterListIcon sx={{ fontSize: 15, color: "primary.main", flexShrink: 0 }} />
//           <Typography sx={{ fontSize: "12px", fontWeight: 600, color: "primary.main", whiteSpace: "nowrap", flexShrink: 0 }}>
//             Filters
//           </Typography>
//           <TextField
//             size="small"
//             placeholder="Search title, company..."
//             value={search}
//             onChange={(event) => setSearch(event.target.value)}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <SearchIcon sx={{ fontSize: 15, color: "text.disabled" }} />
//                 </InputAdornment>
//               ),
//               endAdornment: search ? (
//                 <InputAdornment position="end">
//                   <IconButton size="small" onClick={() => setSearch("")}>
//                     <ClearIcon sx={{ fontSize: 13 }} />
//                   </IconButton>
//                 </InputAdornment>
//               ) : null,
//               sx: { fontSize: "12px", borderRadius: "8px", bgcolor: "#fff" },
//             }}
//             sx={{
//               flex: "1 1 140px",
//               minWidth: 120,
//               maxWidth: 180,
//               "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
//               "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
//               "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "none !important", outline: "none !important" },
//               "& input:focus": { outline: "none !important", boxShadow: "none !important" },
//             }}
//           />
//           {/* <FormControl size="small" sx={{ flex: "1 1 100px", minWidth: 90, maxWidth: 130 }}>
//             <InputLabel sx={{ fontSize: "12px" }}>Location</InputLabel>
//             <Select label="Location" value={filterLocation} onChange={(event: SelectChangeEvent) => setFilterLocation(event.target.value)}
//               sx={{ ...filterSelectSx, width: "100%", minWidth: "unset", maxWidth: "unset", fontSize: "12px" }}
//               MenuProps={{
//                 PaperProps: {
//                   style: {
//                     maxHeight: 220,
//                     overflowY: "auto",
//                   },
//                 },
//               }}
//             >
//               {locationOptions.map((option) => (
//                 <MenuItem key={option} value={option} sx={{ fontSize: "12px" }}>{option}</MenuItem>
//               ))}
//             </Select>
//           </FormControl> */}
          
//           <Autocomplete
//             size="small"
//             options={locationOptions}
//             value={filterLocation}
//             onChange={(_, newValue) => setFilterLocation(newValue ?? "All")}
//             popupIcon={null}
//             renderOption={(props, option) => (
//               <li {...props} style={{ fontSize: "12px" }}>
//                 {option}
//               </li>
//             )}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Location"
//                 placeholder="Search..."
//                 InputLabelProps={{
//                   sx: { fontSize: "12px" },
//                 }}
//                 InputProps={{
//                   ...params.InputProps,
//                   sx: {
//                     fontSize: "12px",
//                     borderRadius: "8px",
//                     bgcolor: "#fff",
//                     height: 34,
//                     paddingRight: "8px !important",
//                     "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
//                     "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
//                     "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" },
//                     "& .MuiOutlinedInput-root.Mui-focused": { boxShadow: "none !important", outline: "none !important" },
//                     "& input:focus": { outline: "none !important", boxShadow: "none !important" },
//                     "& .MuiAutocomplete-clearIndicator": { 
//                       visibility: filterLocation !== "All" ? "visible" : "hidden",
//                       padding: "2px",
//                       "& svg": { fontSize: "14px" },
//                     },
//                   },
//                 }}
//                 sx={{}}
//               />
//             )}
//             ListboxProps={{
//               style: { fontSize: "12px", maxHeight: 220 },
//             }}
//             componentsProps={{
//               paper: {
//                 sx: { width: 220 },
//               },
//               popper: {
//                 placement: "bottom",
//                 modifiers: [
//                   {
//                     name: "offset",
//                     options: { offset: [-35, 4] },
//                   },
//                 ],
//               },
//             }}
//             sx={{
//               flex: "1 1 100px",
//               minWidth: 90,
//               maxWidth: 130,
//             }}
//           />
//           <FormControl size="small" sx={{ flex: "1 1 100px", minWidth: 90, maxWidth: 120 }}>
//             <InputLabel sx={{ fontSize: "12px" }}>Emp. Type</InputLabel>
//             <Select
//               label="Emp. Type"
//               value={filterEmpType}
//               onChange={(event: SelectChangeEvent) => setFilterEmpType(event.target.value)}
//               sx={{ ...filterSelectSx, width: "100%", minWidth: "unset", maxWidth: "unset", fontSize: "12px" }}
//             >
//               {empTypeOptions.map((option) => (
//                 <MenuItem key={option} value={option} sx={{ fontSize: "12px" }}>{option}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl size="small" sx={{ flex: "1 1 100px", minWidth: 90, maxWidth: 120 }}>
//             <InputLabel sx={{ fontSize: "12px" }}>Job Type</InputLabel>
//             <Select
//               label="Job Type"
//               value={filterJobType}
//               onChange={(event: SelectChangeEvent) => setFilterJobType(event.target.value)}
//               sx={{ ...filterSelectSx, width: "100%", minWidth: "unset", maxWidth: "unset", fontSize: "12px" }}
//             >
//               {jobTypeOptions.map((option) => (
//                 <MenuItem key={option} value={option} sx={{ fontSize: "12px" }}>{option}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <CustomDatePicker
//             label="From"
//             value={filterStartDate}
//             onChange={setFilterStartDate}
//             maxDate={filterEndDate || undefined}
//           />
//           <CustomDatePicker
//             label="To"
//             value={filterEndDate}
//             onChange={setFilterEndDate}
//             minDate={filterStartDate || undefined}
//           />
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto", flexShrink: 0 }}>
//             {!loading && !error && (
//               <Typography sx={{ fontSize: "12px", color: "text.disabled", whiteSpace: "nowrap" }}>
//                 {hasActiveFilters
//                   ? `${filteredJobs.length} of ${jobs.length} jobs`
//                   : `${jobs.length} jobs`}
//               </Typography>
//             )}
//             {hasActiveFilters && (
//               <Chip
//                 label="Clear"
//                 size="small"
//                 onDelete={clearFilters}
//                 onClick={clearFilters}
//                 sx={{
//                   fontSize: "11px",
//                   bgcolor: "#fff0f0",
//                   color: "#c62828",
//                   borderColor: "#ffcdd2",
//                   "& .MuiChip-deleteIcon": { color: "#c62828" },
//                 }}
//                 variant="outlined"
//               />
//             )}
//           </Box>
//         </FilterBar>
//       )}

//       <Grid size={8}>
//         {showAppliedJobs ? (
//           <AppliedJobsTable
//             loading={applicationsLoading}
//             records={appliedJobRecords}
//             emptyMessage="No applied job records found."
//           />
//         ) : (
//           <Box sx={{ "& > div": { height: "70vh", backgroundColor: "#fafafa" } }}>
//             <CardScrolingTem>
//             {loading && (
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   py: 6,
//                   gap: 2,
//                 }}
//               >
//                 <CircularProgress size={36} />
//                 <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
//                   Fetching jobs...
//                 </Typography>
//               </Box>
//             )}
//             {!loading && error && (
//               <Box
//                 sx={{
//                   textAlign: "center",
//                   py: 6,
//                   px: 2,
//                   border: "1px dashed #f44336",
//                   borderRadius: "12px",
//                   bgcolor: "#fff5f5",
//                 }}
//               >
//                 <Typography sx={{ color: "#c62828", fontWeight: 600, fontSize: "14px" }}>
//                   Failed to load jobs
//                 </Typography>
//                 <Typography sx={{ color: "text.secondary", fontSize: "13px", mt: 0.5 }}>
//                   {error}
//                 </Typography>
//               </Box>
//             )}
//             {!loading && !error && filteredJobs.length === 0 && (
//               <Box sx={{ textAlign: "center", py: 6 }}>
//                 <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
//                   {hasActiveFilters
//                     ? "No jobs match your filters. Try adjusting or clearing them."
//                     : "No jobs found."}
//                 </Typography>
//               </Box>
//             )}
//             {!loading && !error && filteredJobs.length > 0 && (
//               <Box
//                 key={`${filterLocation}-${filterEmpType}-${filterJobType}-${filterSource}-${search}`}
//                 sx={{
//                   display: "grid",
//                   gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
//                   gap: "14px",
//                 }}
//               >
//                 {filteredJobs.map((job) => {
//                   const record = applicationMap[job.unique_id];
//                   return (
//                     <JobCard key={job.unique_id} sx={{ marginBottom: 0 }}>
//                       <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
//                         <Box sx={{ flex: 1, minWidth: 0 }}>
//                           <Typography
//                             sx={{
//                               fontWeight: 700,
//                               fontSize: "15px",
//                               color: "primary.main",
//                               lineHeight: 1.3,
//                             }}
//                           >
//                             {job.job_title}
//                           </Typography>
//                           <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
//                             <BusinessIcon sx={{ fontSize: 13, color: "text.secondary" }} />
//                             <Typography sx={{ fontSize: "13px", color: "text.secondary" }}>
//                               {job.company}
//                             </Typography>
//                             <Typography sx={{ fontSize: "12px", color: "text.disabled", mx: 0.5 }}>
//                               -
//                             </Typography>
//                             <Typography
//                               sx={{
//                                 fontSize: "12px",
//                                 color: "text.secondary",
//                                 textTransform: "capitalize",
//                               }}
//                             >
//                               {job.source}
//                             </Typography>
//                           </Box>
//                         </Box>
//                         <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
//                           <Tooltip title="View job description">
//                             <IconButton size="small" onClick={() => setJdModal(job)}>
//                               <DescriptionOutlinedIcon sx={{ fontSize: 18, color: "text.secondary" }} />
//                             </IconButton>
//                           </Tooltip>
//                           {record?.feedback === "applied" && (
//                             <Tooltip title="Open job posting">
//                               <IconButton
//                                 size="small"
//                                 onClick={() => window.open(job.job_post_link, "_blank", "noopener,noreferrer")}
//                               >
//                                 <OpenInNewIcon sx={{ fontSize: 18, color: "text.secondary" }} />
//                               </IconButton>
//                             </Tooltip>
//                           )}
//                         </Box>
//                       </Box>
//                       <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1.5 }}>
//                         <Chip
//                           icon={<LocationOnOutlinedIcon sx={{ fontSize: "14px !important" }} />}
//                           label={job.location}
//                           size="small"
//                           sx={{ fontSize: "12px", bgcolor: "#f0f4ff", color: "#1976d2" }}
//                           variant="outlined"
//                         />
//                         {(job.emp_type ?? []).map((empType) => (
//                           <Chip
//                             key={empType}
//                             icon={<WorkOutlineIcon sx={{ fontSize: "14px !important" }} />}
//                             label={empType}
//                             size="small"
//                             sx={{ fontSize: "12px", bgcolor: "#f0fff4", color: "#388e3c" }}
//                             variant="outlined"
//                           />
//                         ))}
//                         {(job.job_type ?? []).map((jobType) => (
//                           <Chip
//                             key={jobType}
//                             label={jobType}
//                             size="small"
//                             sx={{ fontSize: "12px", bgcolor: "#e8f5e9", color: "#2e7d32" }}
//                             variant="outlined"
//                           />
//                         ))}
//                         <Chip
//                           icon={<CalendarTodayIcon sx={{ fontSize: "13px !important" }} />}
//                           label={formatDate(job.date_posted)}
//                           size="small"
//                           sx={{ fontSize: "12px", bgcolor: "#fafafa", color: "text.secondary" }}
//                           variant="outlined"
//                         />
//                       </Box>
//                       <Box
//                         sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}
//                       >
//                         <Button
//                           size="small"
//                           variant="contained"
//                           color={record?.feedback === "applied" ? "success" : "primary"}
//                           disabled={record?.feedback === "applied"}
//                           sx={{ textTransform: "none" }}
//                           onClick={() => {
//                             if (record?.feedback !== "applied") {
//                               setApplyModal(job);
//                             }
//                           }}
//                         >
//                           {record?.feedback === "applied" ? "Applied" : "Apply"}
//                         </Button>
//                       </Box>
//                     </JobCard>
//                   );
//                 })}
//               </Box>
//             )}
//           </CardScrolingTem>
//           </Box>
//         )}
//       </Grid>

//       <Modal open={Boolean(jdModal)} onClose={() => setJdModal(null)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "92%", sm: 930 },
//             maxHeight: "80vh",
//             bgcolor: "#fff",
//             borderRadius: "16px",
//             boxShadow: "0px 8px 32px rgba(0,0,0,0.18)",
//             display: "flex",
//             flexDirection: "column",
//             overflow: "hidden",
//           }}
//         >
//           <Box
//             sx={{
//               px: 3,
//               py: 2,
//               borderBottom: "1px solid #eaf0fb",
//               display: "flex",
//               alignItems: "flex-start",
//               gap: 1.5,
//               bgcolor: "#f7faff",
//             }}
//           >
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "primary.main" }}>
//                 {jdModal?.job_title}
//               </Typography>
//               <Typography sx={{ fontSize: "13px", color: "text.secondary" }}>
//                 {jdModal?.company} - {jdModal?.location}
//               </Typography>
//             </Box>
//             <IconButton size="small" onClick={() => setJdModal(null)}>
//               <CloseIcon sx={{ fontSize: 18 }} />
//             </IconButton>
//           </Box>
//           <Box sx={{ px: 3, py: 2, overflowY: "auto" }}>
//             <Typography
//               sx={{
//                 fontSize: "13px",
//                 color: "text.secondary",
//                 whiteSpace: "pre-line",
//                 lineHeight: 1.7,
//               }}
//             >
//               {jdModal?.jd ?? "No description available."}
//             </Typography>
//           </Box>
//         </Box>
//       </Modal>

//       <Modal open={Boolean(applyModal)} onClose={() => setApplyModal(null)}>
//         <Box
//           sx={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             width: { xs: "92%", sm: 620 },
//             bgcolor: "#fff",
//             borderRadius: "16px",
//             boxShadow: "0px 8px 32px rgba(0,0,0,0.18)",
//             overflow: "hidden",
//           }}
//         >
//           <Box
//             sx={{
//               px: 3,
//               py: 2,
//               borderBottom: "1px solid #eaf0fb",
//               display: "flex",
//               alignItems: "flex-start",
//               gap: 1.5,
//               bgcolor: "#f7faff",
//             }}
//           >
//             <Box sx={{ flex: 1, minWidth: 0 }}>
//               <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "primary.main" }}>
//                 {applyModal?.job_title}
//               </Typography>
//               <Typography sx={{ fontSize: "13px", color: "text.secondary" }}>
//                 {applyModal?.company} - {applyModal?.location}
//               </Typography>
//             </Box>
//             <IconButton size="small" onClick={() => setApplyModal(null)}>
//               <CloseIcon sx={{ fontSize: 18 }} />
//             </IconButton>
//           </Box>
//           <Box sx={{ px: 3, py: 2 }}>
//             <Typography sx={{ fontSize: "13px", color: "text.secondary", mb: 1 }}>
//               Click below to open the original job posting.
//             </Typography>
//             <Button
//               variant="contained"
//               disabled={applyLoading || !applyModal}
//               onClick={() => applyModal && void handleOpenPosting(applyModal)}
//               sx={{ textTransform: "none" }}
//             >
//               {applyLoading ? "Opening..." : "Open Job Posting"}
//             </Button>
//           </Box>
//           <Box
//             sx={{
//               px: 3,
//               py: 2,
//               borderTop: "1px solid #eaf0fb",
//               display: "flex",
//               flexDirection: "column",
//               gap: 1.5,
//             }}
//           >
//             <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>
//               Have you applied to this job?
//             </Typography>
//             <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
//               <Button
//                 variant="outlined"
//                 color="success"
//                 disabled={!hasOpenedSelectedJob || feedbackLoading !== null || !applyModal}
//                 onClick={() => applyModal && void handleSaveFeedback(applyModal, "applied")}
//                 sx={{ textTransform: "none" }}
//               >
//                 {feedbackLoading === "applied" ? "Saving..." : "Applied"}
//               </Button>
//               <Button
//                 variant="outlined"
//                 color="warning"
//                 disabled={!hasOpenedSelectedJob || feedbackLoading !== null || !applyModal}
//                 onClick={() => applyModal && void handleSaveFeedback(applyModal, "not_applied")}
//                 sx={{ textTransform: "none" }}
//               >
//                 {feedbackLoading === "not_applied" ? "Saving..." : "Not applied"}
//               </Button>
//             </Box>
//             {!hasOpenedSelectedJob && (
//               <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
//                 Open the job posting first to enable feedback buttons.
//               </Typography>
//             )}
//             {selectedJobRecord?.feedback && (
//               <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
//                 Current status: {getFeedbackLabel(selectedJobRecord.feedback)}
//               </Typography>
//             )}
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// }

// export default JobsReportPagePreview;

import BusinessIcon from "@mui/icons-material/Business";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import { Autocomplete } from "@mui/material";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { AppliedJobsTable } from "./applied-jobs-table";
import CardScrolingTem from "../dashboard/card-scroling-tem";
import { useUser } from "@/client/services/user";
import {
  JobFeedback,
  InternshipJobApplicationRecord,
  fetchStudentInternshipJobs,
  openInternshipJobLink,
  saveInternshipJobFeedback,
} from "@/client/services/internship-jobs";
import { CustomDatePicker } from "./Customdatepicker";
import axios from "axios";
import { useDeferredValue } from "react";

// ─── Types ────────────────────────────────────────────────────────────────────

interface Job {
  unique_id: string;
  company: string;
  job_title: string;
  location: string;
  emp_type: string[];
  job_type: string[];
  tag: string;
  source: string;
  date_posted?: string;
  linked_date_posted?: string;
  job_post_link: string;
  job_details: {
    experience_required: string;
    degree_required: string;
    employment_type: string[];
  };
  jd: string;
}

interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

interface FilterOptions {
  locations: string[];
  empTypes: string[];
  jobTypes: string[];
  sources: string[];
}

// ─── Constants ────────────────────────────────────────────────────────────────

const PAGE_SIZE = 20;

// ─── Styled components ────────────────────────────────────────────────────────

const JobCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "12px",
  padding: theme.spacing(2.5),
  marginBottom: "14px",
  boxShadow: "0px 1px 4px rgba(0,0,0,0.08)",
  border: "1px solid #eaf0fb",
  transition: "box-shadow 0.2s, border-color 0.2s",
  "&:hover": {
    boxShadow: "0px 4px 16px rgba(25, 118, 210, 0.12)",
    borderColor: "#90caf9",
  },
}));

const FilterBar = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "center",
  gap: theme.spacing(1.5),
  padding: theme.spacing(1.75, 2),
  backgroundColor: "#f7faff",
  borderRadius: "12px",
  border: "1px solid #dde8fb",
  marginBottom: theme.spacing(1.5),
}));

// ─── Helpers ──────────────────────────────────────────────────────────────────

function formatDate(dateStr?: string) {
  if (!dateStr) return "-";
  const [year, month, day] = dateStr.split(" ")[0].split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

const filterSelectSx = {
  fontSize: "13px",
  bgcolor: "#fff",
  borderRadius: "8px",
  width: 140,
  minWidth: 140,
  maxWidth: 140,
  "& .MuiSelect-select": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#1976d2" },
};

const getFeedbackLabel = (feedback?: JobFeedback) => {
  if (feedback === "applied") return "Applied";
  if (feedback === "not_applied") return "Not Applied";
  return "Pending Feedback";
};

// ─── Custom hook: paginated + filtered jobs ───────────────────────────────────

function useJobsFeed(filters: {
  search: string;
  location: string;
  empType: string;
  jobType: string;
  source: string;
  startDate: string;
  endDate: string;
}) {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [filterOptions, setFilterOptions] = useState<FilterOptions>({
    locations: ["All"],
    empTypes: ["All"],
    jobTypes: ["All"],
    sources: ["All"],
  });
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Build query string from filters + page
  const buildParams = useCallback(
    (page: number) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("limit", String(PAGE_SIZE));
      if (filters.search) params.set("search", filters.search);
      if (filters.location !== "All") params.set("location", filters.location);
      if (filters.empType !== "All") params.set("empType", filters.empType);
      if (filters.jobType !== "All") params.set("jobType", filters.jobType);
      if (filters.source !== "All") params.set("source", filters.source);
      if (filters.startDate) params.set("startDate", filters.startDate);
      if (filters.endDate) params.set("endDate", filters.endDate);
      return params.toString();
    },
    [filters],
  );

  // Reset + fetch page 1 whenever filters change
  useEffect(() => {
    let cancelled = false;

    const fetchFirstPage = async () => {
      try {
        setLoading(true);
        setError(null);
        setJobs([]);
        setPagination(null);

        const { data } = await axios.get(
          `/api/internship-jobs?${buildParams(1)}`,
        );

        if (cancelled) return;

        setJobs(data.jobs ?? []);
        setPagination(data.pagination ?? null);
        if (data.filterOptions) setFilterOptions(data.filterOptions);
      } catch (err: unknown) {
        if (!cancelled) {
          setError(
            err instanceof Error ? err.message : "An unexpected error occurred.",
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchFirstPage();
    return () => {
      cancelled = true;
    };
  }, [buildParams]);

  // Load next page (appends to existing jobs)
  const loadMore = useCallback(async () => {
    if (!pagination?.hasNextPage || loadingMore || loading) return;

    try {
      setLoadingMore(true);
      const nextPage = pagination.page + 1;
      const { data } = await axios.get(
        `/api/internship-jobs?${buildParams(nextPage)}`,
      );
      setJobs((prev) => [...prev, ...(data.jobs ?? [])]);
      setPagination(data.pagination ?? null);
    } catch {
      // Silently fail; user can scroll again to retry
    } finally {
      setLoadingMore(false);
    }
  }, [pagination, loadingMore, loading, buildParams]);

  return { jobs, pagination, filterOptions, loading, loadingMore, error, loadMore };
}

// ─── Component ────────────────────────────────────────────────────────────────

function JobsReportPagePreview() {
  const [jdModal, setJdModal] = useState<Job | null>(null);
  const [applyModal, setApplyModal] = useState<Job | null>(null);
  const [applyLoading, setApplyLoading] = useState(false);
  const [feedbackLoading, setFeedbackLoading] = useState<JobFeedback | null>(null);
  const [applicationsLoading, setApplicationsLoading] = useState(true);
  const [applicationMap, setApplicationMap] = useState<
    Record<string, InternshipJobApplicationRecord>
  >({});
  const { user } = useUser();

  // Filter state
  const [search, setSearch] = useState("");
  const [filterLocation, setFilterLocation] = useState("All");
  const [filterEmpType, setFilterEmpType] = useState("All");
  const [filterJobType, setFilterJobType] = useState("All");
  const [filterSource, setFilterSource] = useState("All");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [showAppliedJobs, setShowAppliedJobs] = useState(false);

  // Debounce search so we don't fire a request on every keystroke
  const deferredSearch = useDeferredValue(search);

  const filters = useMemo(
    () => ({
      search: deferredSearch,
      location: filterLocation,
      empType: filterEmpType,
      jobType: filterJobType,
      source: filterSource,
      startDate: filterStartDate,
      endDate: filterEndDate,
    }),
    [
      deferredSearch,
      filterLocation,
      filterEmpType,
      filterJobType,
      filterSource,
      filterStartDate,
      filterEndDate,
    ],
  );

  const { jobs, pagination, filterOptions, loading, loadingMore, error, loadMore } =
    useJobsFeed(filters);

  // ── Infinite scroll sentinel ─────────────────────────────────────────────
  const sentinelRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          loadMore();
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [loadMore]);

  // ── Student applications ─────────────────────────────────────────────────
  useEffect(() => {
    const loadStudentApplications = async () => {
      if (!user?.studentId) {
        setApplicationMap({});
        setApplicationsLoading(false);
        return;
      }
      try {
        setApplicationsLoading(true);
        const records = await fetchStudentInternshipJobs(user.studentId);
        const nextMap = records.reduce<
          Record<string, InternshipJobApplicationRecord>
        >((acc, cur) => {
          acc[cur.jobUniqueId] = cur;
          return acc;
        }, {});
        setApplicationMap(nextMap);
      } catch {
        setApplicationMap({});
      } finally {
        setApplicationsLoading(false);
      }
    };
    loadStudentApplications();
  }, [user?.studentId]);

  // ── Helpers ──────────────────────────────────────────────────────────────
  const hasActiveFilters =
    search !== "" ||
    filterLocation !== "All" ||
    filterEmpType !== "All" ||
    filterJobType !== "All" ||
    filterSource !== "All" ||
    filterStartDate !== "" ||
    filterEndDate !== "";

  const clearFilters = () => {
    setSearch("");
    setFilterLocation("All");
    setFilterEmpType("All");
    setFilterJobType("All");
    setFilterSource("All");
    setFilterStartDate("");
    setFilterEndDate("");
  };

  const updateApplicationMap = (record: InternshipJobApplicationRecord) => {
    setApplicationMap((prev) => ({ ...prev, [record.jobUniqueId]: record }));
  };

  const handleOpenPosting = async (job: Job) => {
    if (!user?.studentId) return;
    try {
      setApplyLoading(true);
      const record = await openInternshipJobLink({
        studentId: user.studentId,
        studentName: user.name,
        studentEmail: user.email,
        studentRollNo: user.rollNo,
        jobUniqueId: job.unique_id,
        jobTitle: job.job_title,
        company: job.company,
        location: job.location,
        source: job.source,
        jobPostLink: job.job_post_link,
      });
      updateApplicationMap(record);
      window.open(job.job_post_link, "_blank", "noopener,noreferrer");
    } finally {
      setApplyLoading(false);
    }
  };

  const handleSaveFeedback = async (job: Job, feedback: JobFeedback) => {
    if (!user?.studentId) return;
    try {
      setFeedbackLoading(feedback);
      const record = await saveInternshipJobFeedback({
        studentId: user.studentId,
        jobUniqueId: job.unique_id,
        feedback,
      });
      updateApplicationMap(record);
      setApplyModal(null);
    } finally {
      setFeedbackLoading(null);
    }
  };

  const selectedJobRecord = applyModal ? applicationMap[applyModal.unique_id] : undefined;
  const hasOpenedSelectedJob = Boolean(selectedJobRecord?.applicationOpenedAt);

  const appliedJobRecords = useMemo(
    () =>
      Object.values(applicationMap).sort(
        (l, r) =>
          new Date(r.updatedAt ?? r.createdAt).getTime() -
          new Date(l.updatedAt ?? l.createdAt).getTime(),
      ),
    [applicationMap],
  );

  // ── Render ───────────────────────────────────────────────────────────────
  return (
    <Box sx={{ flexGrow: 1, px: 1 }}>
      <Grid size={8}>
        {/* Tab Navigation */}
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-end",
            mb: 1.5,
            borderBottom: "2px solid #e0e7f3",
            position: "sticky",
            top: 0,
            zIndex: 10,
            bgcolor: "background.default",
          }}
        >
          <Box
            onClick={() => setShowAppliedJobs(false)}
            sx={{
              px: 2, py: 1, cursor: "pointer", fontSize: "15px",
              fontWeight: showAppliedJobs ? 500 : 700,
              color: showAppliedJobs ? "text.secondary" : "primary.main",
              borderBottom: showAppliedJobs ? "2px solid transparent" : "2px solid #1976d2",
              mb: "-2px", transition: "color 0.15s", userSelect: "none",
              "&:hover": { color: "primary.main" },
            }}
          >
            Jobs
          </Box>
          <Box
            onClick={() => setShowAppliedJobs(true)}
            sx={{
              px: 2, py: 1, cursor: "pointer", fontSize: "15px",
              fontWeight: showAppliedJobs ? 700 : 500,
              color: showAppliedJobs ? "primary.main" : "text.secondary",
              borderBottom: showAppliedJobs ? "2px solid #1976d2" : "2px solid transparent",
              mb: "-2px", transition: "color 0.15s", userSelect: "none",
              "&:hover": { color: "primary.main" },
            }}
          >
            Job Status
          </Box>
        </Box>
      </Grid>

      {/* Filter bar */}
      {!showAppliedJobs && (
        <FilterBar sx={{ flexWrap: "nowrap", alignItems: "center", gap: 1, py: 1.25 }}>
          <FilterListIcon sx={{ fontSize: 15, color: "primary.main", flexShrink: 0 }} />
          <Typography
            sx={{ fontSize: "12px", fontWeight: 600, color: "primary.main", whiteSpace: "nowrap", flexShrink: 0 }}
          >
            Filters
          </Typography>

          {/* Search */}
          <TextField
            size="small"
            placeholder="Search title, company..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 15, color: "text.disabled" }} />
                </InputAdornment>
              ),
              endAdornment: search ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearch("")}>
                    <ClearIcon sx={{ fontSize: 13 }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
              sx: { fontSize: "12px", borderRadius: "8px", bgcolor: "#fff" },
            }}
            sx={{
              flex: "1 1 140px", minWidth: 120, maxWidth: 180,
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
              "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
              "& .MuiOutlinedInput-root.Mui-focused": {
                  boxShadow: "none !important",
                  outline: "none !important",
                },
              "& input:focus": {
                outline: "none !important",
                boxShadow: "none !important",
              },
            }}
          />

          {/* Location */}
          <Autocomplete
            size="small"
            options={filterOptions.locations}
            value={filterLocation}
            onChange={(_, newValue) => setFilterLocation(newValue ?? "All")}
            popupIcon={null}
            renderOption={(props, option) => (
              <li {...props} style={{ fontSize: "12px" }}>{option}</li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Location"
                placeholder="Search..."
                InputLabelProps={{ sx: { fontSize: "12px" } }}
                inputProps={{
                  ...params.inputProps,  // ← lowercase: targets the native <input> element
                  style: { fontSize: "12px" },
                }}
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    fontSize: "12px",
                    borderRadius: "8px",
                    bgcolor: "#fff",
                    height: 34,
                    paddingRight: "8px !important",
                    "& input": {
                      outline: "none !important",
                      boxShadow: "none !important",
                    },
                    "& .MuiAutocomplete-clearIndicator": {
                      visibility: filterLocation !== "All" ? "visible" : "hidden",
                      padding: "2px",
                      "& svg": { fontSize: "14px" },
                    },
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#dde8fb" },
                  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#90caf9" },
                  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#1976d2",
                  },
                }}
              />
            )}
            ListboxProps={{ style: { fontSize: "12px", maxHeight: 220 } }}
            componentsProps={{
              paper: { sx: { width: 220 } },
              popper: {
                placement: "bottom",
                modifiers: [{ name: "offset", options: { offset: [-35, 4] } }],
              },
            }}
            sx={{ flex: "1 1 100px", minWidth: 90, maxWidth: 130 }}
          />

          {/* Emp Type */}
          <FormControl size="small" sx={{ flex: "1 1 100px", minWidth: 90, maxWidth: 120 }}>
            <InputLabel sx={{ fontSize: "12px" }}>Emp. Type</InputLabel>
            <Select
              label="Emp. Type"
              value={filterEmpType}
              onChange={(e: SelectChangeEvent) => setFilterEmpType(e.target.value)}
              sx={{ ...filterSelectSx, width: "100%", minWidth: "unset", maxWidth: "unset", fontSize: "12px" }}
            >
              {filterOptions.empTypes.map((opt) => (
                <MenuItem key={opt} value={opt} sx={{ fontSize: "12px" }}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Job Type */}
          <FormControl size="small" sx={{ flex: "1 1 100px", minWidth: 90, maxWidth: 120 }}>
            <InputLabel sx={{ fontSize: "12px" }}>Job Type</InputLabel>
            <Select
              label="Job Type"
              value={filterJobType}
              onChange={(e: SelectChangeEvent) => setFilterJobType(e.target.value)}
              sx={{ ...filterSelectSx, width: "100%", minWidth: "unset", maxWidth: "unset", fontSize: "12px" }}
            >
              {filterOptions.jobTypes.map((opt) => (
                <MenuItem key={opt} value={opt} sx={{ fontSize: "12px" }}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <CustomDatePicker label="From" value={filterStartDate} onChange={setFilterStartDate} maxDate={filterEndDate || undefined} />
          <CustomDatePicker label="To" value={filterEndDate} onChange={setFilterEndDate} minDate={filterStartDate || undefined} />

          {/* Job count + clear */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto", flexShrink: 0 }}>
            {!loading && !error && pagination && (
              <Typography sx={{ fontSize: "12px", color: "text.disabled", whiteSpace: "nowrap" }}>
                {hasActiveFilters
                  ? `${pagination.total} of all jobs`
                  : `${pagination.total} jobs`}
              </Typography>
            )}
            {hasActiveFilters && (
              <Chip
                label="Clear"
                size="small"
                onDelete={clearFilters}
                onClick={clearFilters}
                sx={{
                  fontSize: "11px", bgcolor: "#fff0f0", color: "#c62828",
                  borderColor: "#ffcdd2", "& .MuiChip-deleteIcon": { color: "#c62828" },
                }}
                variant="outlined"
              />
            )}
          </Box>
        </FilterBar>
      )}

      <Grid size={8}>
        {showAppliedJobs ? (
          <AppliedJobsTable
            loading={applicationsLoading}
            records={appliedJobRecords}
            emptyMessage="No applied job records found."
          />
        ) : (
          <Box sx={{ "& > div": { height: "70vh", backgroundColor: "#fafafa" } }}>
            <CardScrolingTem>
              {/* Initial load */}
              {loading && (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", py: 6, gap: 2 }}>
                  <CircularProgress size={36} />
                  <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>Fetching jobs...</Typography>
                </Box>
              )}

              {/* Error */}
              {!loading && error && (
                <Box sx={{ textAlign: "center", py: 6, px: 2, border: "1px dashed #f44336", borderRadius: "12px", bgcolor: "#fff5f5" }}>
                  <Typography sx={{ color: "#c62828", fontWeight: 600, fontSize: "14px" }}>Failed to load jobs</Typography>
                  <Typography sx={{ color: "text.secondary", fontSize: "13px", mt: 0.5 }}>{error}</Typography>
                </Box>
              )}

              {/* Empty */}
              {!loading && !error && jobs.length === 0 && (
                <Box sx={{ textAlign: "center", py: 6 }}>
                  <Typography sx={{ color: "text.secondary", fontSize: "14px" }}>
                    {hasActiveFilters
                      ? "No jobs match your filters. Try adjusting or clearing them."
                      : "No jobs found."}
                  </Typography>
                </Box>
              )}

              {/* Job cards */}
              {!loading && !error && jobs.length > 0 && (
                <Box
                  sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: "14px" }}
                >
                  {jobs.map((job) => {
                    const record = applicationMap[job.unique_id];
                    return (
                      <JobCard key={job.unique_id} sx={{ marginBottom: 0 }}>
                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
                          <Box sx={{ flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "primary.main", lineHeight: 1.3 }}>
                              {job.job_title}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
                              <BusinessIcon sx={{ fontSize: 13, color: "text.secondary" }} />
                              <Typography sx={{ fontSize: "13px", color: "text.secondary" }}>{job.company}</Typography>
                              <Typography sx={{ fontSize: "12px", color: "text.disabled", mx: 0.5 }}>-</Typography>
                              <Typography sx={{ fontSize: "12px", color: "text.secondary", textTransform: "capitalize" }}>
                                {job.source}
                              </Typography>
                            </Box>
                          </Box>
                          <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
                            <Tooltip title="View job description">
                              <IconButton size="small" onClick={() => setJdModal(job)}>
                                <DescriptionOutlinedIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                              </IconButton>
                            </Tooltip>
                            {record?.feedback === "applied" && (
                              <Tooltip title="Open job posting">
                                <IconButton
                                  size="small"
                                  onClick={() => window.open(job.job_post_link, "_blank", "noopener,noreferrer")}
                                >
                                  <OpenInNewIcon sx={{ fontSize: 18, color: "text.secondary" }} />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </Box>

                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 1.5 }}>
                          <Chip
                            icon={<LocationOnOutlinedIcon sx={{ fontSize: "14px !important" }} />}
                            label={job.location} size="small"
                            sx={{ fontSize: "12px", bgcolor: "#f0f4ff", color: "#1976d2" }} variant="outlined"
                          />
                          {(job.emp_type ?? []).map((empType) => (
                            <Chip
                              key={empType}
                              icon={<WorkOutlineIcon sx={{ fontSize: "14px !important" }} />}
                              label={empType} size="small"
                              sx={{ fontSize: "12px", bgcolor: "#f0fff4", color: "#388e3c" }} variant="outlined"
                            />
                          ))}
                          {(job.job_type ?? []).map((jobType) => (
                            <Chip key={jobType} label={jobType} size="small"
                              sx={{ fontSize: "12px", bgcolor: "#e8f5e9", color: "#2e7d32" }} variant="outlined"
                            />
                          ))}
                          <Chip
                            icon={<CalendarTodayIcon sx={{ fontSize: "13px !important" }} />}
                            label={formatDate(job.date_posted)} size="small"
                            sx={{ fontSize: "12px", bgcolor: "#fafafa", color: "text.secondary" }} variant="outlined"
                          />
                        </Box>

                        <Box sx={{ mt: 2, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                          <Button
                            size="small"
                            variant="contained"
                            color={record?.feedback === "applied" ? "success" : "primary"}
                            disabled={record?.feedback === "applied"}
                            sx={{ textTransform: "none" }}
                            onClick={() => {
                              if (record?.feedback !== "applied") setApplyModal(job);
                            }}
                          >
                            {record?.feedback === "applied" ? "Applied" : "Apply"}
                          </Button>
                        </Box>
                      </JobCard>
                    );
                  })}
                </Box>
              )}

              {/* ── Infinite scroll sentinel ── */}
              {!loading && !error && jobs.length > 0 && (
                <Box
                  ref={sentinelRef}
                  sx={{ display: "flex", justifyContent: "center", py: 3, mt: 1 }}
                >
                  {loadingMore ? (
                    <CircularProgress size={24} />
                  ) : pagination?.hasNextPage ? (
                    // Invisible target for IntersectionObserver
                    <Box sx={{ height: 1 }} />
                  ) : (
                    <Typography sx={{ fontSize: "12px", color: "text.disabled" }}>
                      All {pagination?.total} jobs loaded
                    </Typography>
                  )}
                </Box>
              )}
            </CardScrolingTem>
          </Box>
        )}
      </Grid>

      {/* JD Modal */}
      <Modal open={Boolean(jdModal)} onClose={() => setJdModal(null)}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: { xs: "92%", sm: 930 }, maxHeight: "80vh", bgcolor: "#fff",
          borderRadius: "16px", boxShadow: "0px 8px 32px rgba(0,0,0,0.18)",
          display: "flex", flexDirection: "column", overflow: "hidden",
        }}>
          <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #eaf0fb", display: "flex", alignItems: "flex-start", gap: 1.5, bgcolor: "#f7faff" }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "primary.main" }}>{jdModal?.job_title}</Typography>
              <Typography sx={{ fontSize: "13px", color: "text.secondary" }}>{jdModal?.company} - {jdModal?.location}</Typography>
            </Box>
            <IconButton size="small" onClick={() => setJdModal(null)}>
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
          <Box sx={{ px: 3, py: 2, overflowY: "auto" }}>
            <Typography sx={{ fontSize: "13px", color: "text.secondary", whiteSpace: "pre-line", lineHeight: 1.7 }}>
              {jdModal?.jd ?? "No description available."}
            </Typography>
          </Box>
        </Box>
      </Modal>

      {/* Apply Modal */}
      <Modal open={Boolean(applyModal)} onClose={() => setApplyModal(null)}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
          width: { xs: "92%", sm: 620 }, bgcolor: "#fff",
          borderRadius: "16px", boxShadow: "0px 8px 32px rgba(0,0,0,0.18)", overflow: "hidden",
        }}>
          <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #eaf0fb", display: "flex", alignItems: "flex-start", gap: 1.5, bgcolor: "#f7faff" }}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ fontWeight: 700, fontSize: "15px", color: "primary.main" }}>{applyModal?.job_title}</Typography>
              <Typography sx={{ fontSize: "13px", color: "text.secondary" }}>{applyModal?.company} - {applyModal?.location}</Typography>
            </Box>
            <IconButton size="small" onClick={() => setApplyModal(null)}>
              <CloseIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
          <Box sx={{ px: 3, py: 2 }}>
            <Typography sx={{ fontSize: "13px", color: "text.secondary", mb: 1 }}>
              Click below to open the original job posting.
            </Typography>
            <Button
              variant="contained"
              disabled={applyLoading || !applyModal}
              onClick={() => applyModal && void handleOpenPosting(applyModal)}
              sx={{ textTransform: "none" }}
            >
              {applyLoading ? "Opening..." : "Open Job Posting"}
            </Button>
          </Box>
          <Box sx={{ px: 3, py: 2, borderTop: "1px solid #eaf0fb", display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Typography sx={{ fontSize: "13px", fontWeight: 600 }}>Have you applied to this job?</Typography>
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Button
                variant="outlined" color="success"
                disabled={!hasOpenedSelectedJob || feedbackLoading !== null || !applyModal}
                onClick={() => applyModal && void handleSaveFeedback(applyModal, "applied")}
                sx={{ textTransform: "none" }}
              >
                {feedbackLoading === "applied" ? "Saving..." : "Applied"}
              </Button>
              <Button
                variant="outlined" color="warning"
                disabled={!hasOpenedSelectedJob || feedbackLoading !== null || !applyModal}
                onClick={() => applyModal && void handleSaveFeedback(applyModal, "not_applied")}
                sx={{ textTransform: "none" }}
              >
                {feedbackLoading === "not_applied" ? "Saving..." : "Not applied"}
              </Button>
            </Box>
            {!hasOpenedSelectedJob && (
              <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                Open the job posting first to enable feedback buttons.
              </Typography>
            )}
            {selectedJobRecord?.feedback && (
              <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
                Current status: {getFeedbackLabel(selectedJobRecord.feedback)}
              </Typography>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default JobsReportPagePreview;